import i18next from 'i18next';

export default function initI18n(): void {
  i18next.addResourceBundle('en', 'site-template-ui', {
    modeTogglerLight: 'Light mode',
    modeTogglerSystem: 'Use system setting',
    modeTogglerDark: 'Dark mode',
    backMidnightStaticNoisePattern: 'Seamless Pattern Horiz Noise@0.25x-8',
    backMidnightStaticTopRight: 'Top Right',
    backMidnightStaticBottomLeft: 'Bottom Left',
    footerMoreThemes: 'More Themes',
    privacyTogglerPrivateLabel: 'Private - Your private items are hidden.',
    privacyTogglerPrivateHint: 'Click to make them visible.',
    privacyTogglerNotPrivateLabel: 'Not private - Your private items are visible.',
    privacyTogglerNotPrivateHint: 'Click to hide them.',
    navHeaderCloseSidebar: 'Close sidebar',
  });
}
